module.exports = __webpack_public_path__ + "img/发票示例2.fc722b0f.png";